<script>
	import { preventDefault } from 'svelte/legacy';
    import {environment} from '@app/store/envStore.svelte.js';
	import { fade } from "svelte/transition";
	import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
	import { toast } from '@zerodevx/svelte-toast';
	import firebase from "@app/configs/firebase.js";
	import db from "@app/configs/firestore.js";
	import _StyleGuide from "@cclib/classes/styleGuide.js";
	import * as m from "@app/paraglide/messages.js";

	let selectedGuide = $state(),
		styleGuides = $state([]),
		userId = environment.online ? firebase.auth().currentUser.uid : null,
		homeRef = environment.online ? db.collection("users").doc(userId).collection("guides") : null,
		gettingStyleGuides = $state(getStyleGuides());

    function close() {
        try {
            //Get button by id of resetPanelBtn and click it if it's visible. 
            let resetPanelBtn = document.getElementById("resetPanelBtn");
            let startQcBtn = document.getElementById("startReviewBtn");
            if (resetPanelBtn){
                resetPanelBtn.click();
                startQcBtn.click();
            }
        } catch (e){
            console.log(e);
        }        

        hideModal();
    }

	function getStyleGuides() {
        styleGuides = [];
        //Refactor code to use local storage when environment.online is false
        if (environment.online){
            return homeRef
			.get()
			.then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					styleGuides = [...styleGuides, doc.data()];
				});

				selectedGuide = styleGuides[0];
			})

			.catch((error) => {
				console.log("Error getting style guides: ", error);
				toast.push(error.message, {classes: ['toast-danger']});
			});
        } else {
            styleGuides = JSON.parse(localStorage.getItem("cc-style-guides")) || [];
            selectedGuide = styleGuides.length > 0 ? styleGuides[0] : null;
        }		
	}

	function createStyleGuide() {
		let newStyleGuide = {...(new _StyleGuide())};
		let styleGuideObject = JSON.parse(JSON.stringify(newStyleGuide));
        //Refactor to use Local Storage isntead of firebase when environment.online is false 
        if (environment.online){
            homeRef
			.doc(newStyleGuide.id)
			.set(styleGuideObject)
			.then(() => {
				toast.push(m.style_guide_manager_created_toast(), {classes: ['toast-success']});

				styleGuides = [...styleGuides, newStyleGuide];
				selectedGuide = styleGuides[styleGuides.length - 1];
			})
			.catch((error) => {
				console.log("Error writing new guide: ", error);
				toast.push(error.message, {classes: ['toast-danger']});
			});
        } else {
            styleGuides = [...styleGuides, newStyleGuide];
            selectedGuide = styleGuides[styleGuides.length - 1];
            localStorage.setItem("cc-style-guides", JSON.stringify(styleGuides));
			toast.push(m.style_guide_manager_created_toast(), {classes: ['toast-success']});
        }
	}

	function removeStyleGuide(id) {
        // Refactor code to use Local Storage instead of firebase when environment.online is false
        if (environment.online){
            homeRef
			.doc(id)
			.delete()
			.then(() => {
				toast.push(m.style_guide_manager_removed_toast(), {classes: ['toast-success']});
			})
			.catch((e) => {
				console.log(e.message, e);
				toast.push(`${m.style_guide_manager_remove_failed_toast()} ${e.message}`, {classes: ['toast-danger']});
			}).finally(() =>{
                gettingStyleGuides = getStyleGuides();
            });
        } else {
            let index = styleGuides.findIndex(styleGuide => {
                return styleGuide.id === id;
            });

            styleGuides.splice(index, 1);
            localStorage.setItem("cc-style-guides", JSON.stringify(styleGuides));
			toast.push(m.style_guide_manager_removed_toast(), {classes: ['toast-success']});
            gettingStyleGuides = getStyleGuides();
        }		
	}

	function selectGuide(guide) {
		selectedGuide = guide;
	}

	function toggleGuide(guide) {
        guide.enabled = !guide.enabled;
        
        if (guide.id === selectedGuide.id){
            selectedGuide.enabled = guide.enabled;
        }

        saveGuide(guide);
    }

	function saveGuide(guide) {
        if (!guide){
            return;
        }

		let styleGuideObject = JSON.parse(JSON.stringify(guide));

        // Refactor to use local storage instead of firebase when environment.online is false
        if (environment.online){
            homeRef
			.doc(guide.id)
			.update(styleGuideObject)
			.then(() => {
                let index = styleGuides.findIndex(styleGuide =>{
                    return styleGuide.id === guide.id
                });

                styleGuides[index] = guide;

				toast.push(m.style_guide_manager_saved_toast(), {classes: ['toast-success']});
			})
			.catch((error) => {
				console.log("Error saving guide: ", error);
				toast.push(error.message, {classes: ['toast-danger']});

                gettingStyleGuides = getStyleGuides();
			});
        } else {
            let index = styleGuides.findIndex(styleGuide =>{
                return styleGuide.id === guide.id
            });

            styleGuides[index] = guide;
            localStorage.setItem("cc-style-guides", JSON.stringify(styleGuides));
			toast.push(m.style_guide_manager_saved_toast(), {classes: ['toast-success']});
        }
            
		
	}
</script>

<div 
    transition:fade={{ duration: 100 }} 
    class="modal {modalState.selected === 'styleGuideManager' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="styleGuideManagerTitle"
    aria-modal="true"
    tabindex="-1" 
    id="StyleGuideManageModal">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
				<h4 class="modal-title" id="styleGuideManagerTitle">{m.style_guide_manager_title()}</h4>
				<button type="button" class="btn-close" aria-label={m.style_guide_manager_close_aria_label()} onclick={()  => close()}></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-3 border-end border-secondary">
                        <div class="d-flex justify-content-end mb-2">
                            <button 
                                type="button" 
                                class="btn btn-primary btn-sm me-2" 
                                id="newGuideBtn"
								aria-label={m.style_guide_manager_create_aria_label()} 
                                onclick={createStyleGuide}>
								<i class="bi bi-plus-lg" aria-hidden="true"></i> {m.style_guide_manager_new_button()}
                            </button>

                            <button 
                                type="button" 
                                class="btn btn-danger btn-sm {selectedGuide ? '' : 'disabled'}" 
                                id="removeGuideBtn"
								aria-label={m.style_guide_manager_remove_aria_label()}
                                aria-disabled={!selectedGuide}
                                onclick={() => removeStyleGuide(selectedGuide.id)}>
								<i class="bi bi-x-lg" aria-hidden="true"></i> {m.style_guide_manager_remove_button()}
                            </button>
                        </div>
						<nav aria-label={m.style_guide_manager_list_aria_label()}>
                            <ul class="nav nav-pills flex-column" role="tablist">
                                {#await gettingStyleGuides}
									<p aria-live="polite">{m.style_guide_manager_loading_label()}</p>
                                {:then}
                                    {#each styleGuides as guide (guide.id)}
                                        <li class="nav-item" role="presentation">
                                            <a 
                                                class="nav-link {selectedGuide && selectedGuide.id === guide.id ? 'active' : ''}" 
                                                href="#!/"
                                                role="tab"
                                                id="guide-tab-{guide.id}"
                                                aria-selected={selectedGuide && selectedGuide.id === guide.id}
                                                onclick={() => selectGuide(guide)}>
                                                {guide.name} 
                                                <input 
                                                    class="form-check-input float-end" 
                                                    type="checkbox" 
                                                    id="guide-enable-{guide.id}"
													aria-label={m.style_guide_manager_enable_guide_aria({ name: guide.name })}
                                                    checked={guide.enabled} 
                                                    onchange={toggleGuide(guide)} />
                                            </a>
                                        </li>
                                    {:else}
										<p class="text-muted small text-center my-5" role="status">{m.style_guide_manager_empty_state()}</p>
                                    {/each}
                                {/await}
                            </ul>
                        </nav>
                    </div>
					<div id="StyleGuideEditSection" class="col" role="tabpanel" aria-label={m.style_guide_manager_settings_aria_label()}>
                        {#if selectedGuide}
							<form onsubmit={preventDefault(saveGuide(selectedGuide))} aria-label={m.style_guide_manager_settings_form_aria_label()}>
								<h2 class="lead text-warning">{m.style_guide_manager_general_settings_label()}</h2>
                                <div class="mb-3 form-check form-switch">
                                    <input 
                                        type="checkbox" 
                                        class="form-check-input" 
                                        id="enableCheck-{selectedGuide.id}" 
                                        bind:checked={selectedGuide.enabled} 
										aria-label={m.style_guide_manager_toggle_visibility_aria_label()} />
                                    <label class="form-check-label" for="enableCheck-{selectedGuide.id}">
										{selectedGuide.enabled ? m.style_guide_manager_visibility_visible() : m.style_guide_manager_visibility_hidden()}
                                    </label>
                                </div>
                                <div class="mb-3">
									<label class="form-label" for="guideName-{selectedGuide.id}">{m.style_guide_manager_name_label()}</label>
                                    <input 
                                        class="form-control" 
                                        type="text" 
                                        id="guideName-{selectedGuide.id}"
                                        required 
                                        bind:value={selectedGuide.name} 
                                        aria-required="true" />
                                </div>
                                <div class="row">
									<div class="mb-3 col-12">
										<label class="form-label" for="Max Characters per Event">{m.style_guide_manager_total_characters_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" max="9999" step="1" bind:value={selectedGuide.totalMaxChars} />
									</div>
									<div class="mb-3 col-12">
										<label class="form-label" for="Max Characters per Line">{m.style_guide_manager_max_characters_per_line_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" max="50" step="1" bind:value={selectedGuide.maxChars} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Min Event Lines">{m.style_guide_manager_min_event_lines_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" max="5" step="1" bind:value={selectedGuide.minLines} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Max Event Lines">{m.style_guide_manager_max_event_lines_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" max="5" step="1" bind:value={selectedGuide.maxLines} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Min Words Per Line">{m.style_guide_manager_min_words_per_line_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" max="99" step="1" bind:value={selectedGuide.minWordsPerLine} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Max Words Per Line">{m.style_guide_manager_max_words_per_line_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" max="99" step="1" bind:value={selectedGuide.maxWordsPerLine} />
									</div>
								</div>
								<div class="row">
									<div class="col-6">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="overlapCheck" bind:checked={selectedGuide.overlap} />
											<label class="form-check-label" for="overlapCheck">{m.style_guide_manager_detect_overlap_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_detect_overlap_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="illegalCharsCheck" bind:checked={selectedGuide.illegalChars} />
											<label class="form-check-label" for="illegalCharsCheck">{m.style_guide_manager_detect_illegal_608_label()}</label>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="missingSpeakerCheck" bind:checked={selectedGuide.missingSpeaker} />
											<label class="form-check-label" for="missingSpeakerCheck">{m.style_guide_manager_missing_speaker_label()}</label>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="netflixGlyphsCheck" bind:checked={selectedGuide.netflixGlyphs} />
											<label class="form-check-label" for="netflixGlyphsCheck">{m.style_guide_manager_detect_illegal_netflix_label()}</label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_event_duration_label()}</p>
								<div class="row">
									<div class="mb-3 col">
										<label class="form-label" for="Minimum duration in seconds">{m.style_guide_manager_min_duration_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0.01" max="25" step="0.01" bind:value={selectedGuide.minDuration} />
									</div>
									<div class="mb-3 col">
										<label class="form-label" for="Maximum duration in seconds">{m.style_guide_manager_max_duration_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0.01" max="25" step="0.01" bind:value={selectedGuide.maxDuration} />
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_cps_label()}</p>
								<div class="row">
									<div class="mb-3 col">
										<label class="form-label" for="Minimum CPS">{m.style_guide_manager_min_cps_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" step="1" bind:value={selectedGuide.minCps} />
									</div>
									<div class="mb-3 col">
										<label class="form-label" for="Maximum CPS">{m.style_guide_manager_max_cps_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" step="1" bind:value={selectedGuide.maxCps} />
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_wpm_label()}</p>
								<div class="row">
									<div class="mb-3 col">
										<label class="form-label" for="Minimum WPM">{m.style_guide_manager_min_wpm_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" step="1" bind:value={selectedGuide.minWpm} />
									</div>
									<div class="mb-3 col">
										<label class="form-label" for="Maximum WPM">{m.style_guide_manager_max_wpm_label()}</label>
										<input class="form-control form-control-sm" type="number" min="1" step="1" bind:value={selectedGuide.maxWpm} />
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_event_gap_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_event_gap_tooltip()}></i></p>
								<div class="row">
									<div class="mb-3 col-6">
										<label class="form-label" for="Minimum Event Gap">{m.style_guide_manager_min_event_gap_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" step="1" bind:value={selectedGuide.minEventGap} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Maximum Event Gap">{m.style_guide_manager_max_event_gap_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" step="1" bind:value={selectedGuide.maxEventGap} />
									</div>
                                    <div class="mb-3 col-6">
										<label class="form-label" for="Minimum Event Gap Tolerance">{m.style_guide_manager_min_event_gap_tolerance_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" step="1" bind:value={selectedGuide.minEventGapTolerance} />
									</div>
									<div class="mb-3 col-6">
										<label class="form-label" for="Maximum Event Gap Tolerance">{m.style_guide_manager_max_event_gap_tolerance_label()}</label>
										<input class="form-control form-control-sm" type="number" min="0" step="1" bind:value={selectedGuide.maxEventGapTolerance} />
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_approvals_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="approvalPassedCheck" bind:checked={selectedGuide.approvalPassed} />
											<label class="form-check-label" for="approvalPassedCheck">{m.style_guide_manager_approval_passed_label()}</label>
										</div>
									</div>

									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="approvalFailedCheck" bind:checked={selectedGuide.approvalFailed} />
											<label class="form-check-label" for="approvalFailedCheck">{m.style_guide_manager_approval_failed_label()}</label>
										</div>
									</div>

									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="approvalNotSetCheck" bind:checked={selectedGuide.approvalNotSet} />
											<label class="form-check-label" for="approvalNotSetCheck">{m.style_guide_manager_approval_not_set_label()}</label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_metadata_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="notesCheck" bind:checked={selectedGuide.notes} />
											<label class="form-check-label" for="notesCheck"> {m.style_guide_manager_notes_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="replyCheck" bind:checked={selectedGuide.reply} />
											<label class="form-check-label" for="replyCheck"> {m.style_guide_manager_reply_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="notesDoneCheck" bind:checked={selectedGuide.notesDone} />
											<label class="form-check-label" for="notesDoneCheck"> {m.style_guide_manager_notes_incomplete_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="replyDoneCheck" bind:checked={selectedGuide.replyDone} />
											<label class="form-check-label" for="replyDoneCheck"> {m.style_guide_manager_reply_incomplete_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="tagsCheck" bind:checked={selectedGuide.tags} />
											<label class="form-check-label" for="tagsCheck"> {m.style_guide_manager_tags_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="forcedSubtitleCheck" bind:checked={selectedGuide.forced} />
											<label class="form-check-label" for="forcedSubtitleCheck"> {m.style_guide_manager_forced_subtitle_label()}</label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_formatting_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="partialBoldCheck" bind:checked={selectedGuide.partialBold} />
											<label class="form-check-label" for="partialBoldCheck">{m.style_guide_manager_partial_bold_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_partial_bold_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="fullBoldCheck" bind:checked={selectedGuide.fullBold} />
											<label class="form-check-label" for="fullBoldCheck">{m.style_guide_manager_bold_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_bold_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="partialUnderlineCheck" bind:checked={selectedGuide.partialUnderline} />
											<label class="form-check-label" for="partialUnderlineCheck">{m.style_guide_manager_partial_underline_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_partial_underline_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="fullUnderlineCheck" bind:checked={selectedGuide.fullUnderline} />
											<label class="form-check-label" for="fullUnderlineCheck">{m.style_guide_manager_underline_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_underline_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="partialItalicsCheck" bind:checked={selectedGuide.partialItalics} />
											<label class="form-check-label" for="partialItalicsCheck">{m.style_guide_manager_partial_italics_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_partial_italics_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="fullItalicsCheck" bind:checked={selectedGuide.fullItalics} />
											<label class="form-check-label" for="fullItalicsCheck">{m.style_guide_manager_italics_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_italics_tooltip()}></i></label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_position_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionTopLeftCheck" bind:checked={selectedGuide.positionTopLeft} />
											<label class="form-check-label" for="positionTopLeftCheck">{m.style_guide_manager_position_top_left_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionTopCenterCheck" bind:checked={selectedGuide.positionTopCenter} />
											<label class="form-check-label" for="positionTopCenterCheck">{m.style_guide_manager_position_top_center_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionTopRightCheck" bind:checked={selectedGuide.positionTopRight} />
											<label class="form-check-label" for="positionTopRightCheck">{m.style_guide_manager_position_top_right_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionCenterLeftCheck" bind:checked={selectedGuide.positionCenterLeft} />
											<label class="form-check-label" for="positionCenterLeftCheck">{m.style_guide_manager_position_center_left_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionCenterCheck" bind:checked={selectedGuide.positionCenter} />
											<label class="form-check-label" for="positionCenterCheck">{m.style_guide_manager_position_center_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionCenterRightCheck" bind:checked={selectedGuide.positionCenterRight} />
											<label class="form-check-label" for="positionCenterRightCheck">{m.style_guide_manager_position_center_right_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionBottomLeftCheck" bind:checked={selectedGuide.positionBottomLeft} />
											<label class="form-check-label" for="positionBottomLeftCheck">{m.style_guide_manager_position_bottom_left_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionBottomCenterCheck" bind:checked={selectedGuide.positionBottomCenter} />
											<label class="form-check-label" for="positionBottomCenterCheck">{m.style_guide_manager_position_bottom_center_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionBottomRightCheck" bind:checked={selectedGuide.positionBottomRight} />
											<label class="form-check-label" for="positionBottomRightCheck">{m.style_guide_manager_position_bottom_right_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionXOffsetCheck" bind:checked={selectedGuide.positionXOffset} />
											<label class="form-check-label" for="positionXOffsetCheck">{m.style_guide_manager_position_x_offset_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_position_x_offset_tooltip()}></i></label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="positionYOffsetCheck" bind:checked={selectedGuide.positionYOffset} />
											<label class="form-check-label" for="positionYOffsetCheck">{m.style_guide_manager_position_y_offset_label()} <i class="bi bi-info-circle" title={m.style_guide_manager_position_y_offset_tooltip()}></i></label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_text_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="hyphenSpaceCheck" bind:checked={selectedGuide.hyphenSpace} />
											<label class="form-check-label" for="hyphenSpaceCheck">{m.style_guide_manager_hyphen_space_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="hasUnderscoreCheck" bind:checked={selectedGuide.hasUnderscore} />
											<label class="form-check-label" for="hasUnderscoreCheck">{m.style_guide_manager_underscore_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="periodsCheck" bind:checked={selectedGuide.periods} />
											<label class="form-check-label" for="periodsCheck">{m.style_guide_manager_dots_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="useEllipsesCheck" bind:checked={selectedGuide.useEllipses} />
											<label class="form-check-label" for="useEllipsesCheck">{m.style_guide_manager_missing_ellipses_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="spellNumbersCheck" bind:checked={selectedGuide.spellNumbers} />
											<label class="form-check-label" for="spellNumbersCheck">{m.style_guide_manager_spell_numbers_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="spellNumbersAtStartCheck" bind:checked={selectedGuide.spellNumbersAtStart} />
											<label class="form-check-label" for="spellNumbersAtStartCheck">{m.style_guide_manager_spell_numbers_start_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="repeatWordsCheck" bind:checked={selectedGuide.repeatWords} />
											<label class="form-check-label" for="repeatWordsCheck">{m.style_guide_manager_repeat_words_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="fitSubtitlesCheck" bind:checked={selectedGuide.fitSubtitles} />
											<label class="form-check-label" for="fitSubtitlesCheck">{m.style_guide_manager_fit_single_line_label()}</label>
										</div>
									</div>
								</div>
								<p class="lead text-warning">{m.style_guide_manager_whitespace_label()}</p>
								<div class="row">
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="leadingTrailingSpaceCheck" bind:checked={selectedGuide.leadingTrailingSpace} />
											<label class="form-check-label" for="leadingTrailingSpaceCheck">{m.style_guide_manager_leading_trailing_spaces_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="whitespaceCheck" bind:checked={selectedGuide.whitespace} />
											<label class="form-check-label" for="whitespaceCheck">{m.style_guide_manager_whitespace_option_label()}</label>
										</div>
									</div>
									<div class="col-4">
										<div class="mb-3 form-check form-switch">
											<input type="checkbox" class="form-check-input" id="blankLinesCheck" bind:checked={selectedGuide.blankLines} />
											<label class="form-check-label" for="blankLinesCheck">{m.style_guide_manager_blank_lines_label()}</label>
										</div>
									</div>
								</div>
								<hr />
							</form>
                        {:else}
	                            <p class="text-center text-muted lead my-5" role="status">{m.style_guide_manager_select_prompt()}</p>
                        {/if}
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                {#if selectedGuide}
                    <button 
                        type="button" 
                        class="btn btn-primary" 
                        id="saveGuideBtn"
                        onclick={() => saveGuide(selectedGuide)} 
                        disabled={!selectedGuide.name || selectedGuide.name === "none"}
                        aria-disabled={!selectedGuide.name || selectedGuide.name === "none"}>
						{m.style_guide_manager_save_button()}
                    </button>
                {:else}
                    <button 
                        type="button" 
                        class="btn btn-light" 
                        id="closeModalBtn"
                        onclick={() => close()}>
						{m.style_guide_manager_close_button()}
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

<style lang="css">
	#StyleGuideEditSection {
		max-height: 70vh;
		overflow-y: auto;
	}
</style>
